import { TemplateOption } from '@/types/template.types';
import { useMemo } from 'react';
import { ReadTemplate, useGetTemplatesForLocationQuery } from '../gql/graphql.generated';
import { useMyLocation } from '../useLocations';

const BUSYNESS_TARGET_NAME = 'Prediction';

const getPropertiesFromTemplate = (template: ReadTemplate) => {
  if (!template.properties) {
    return {};
  }

  try {
    const properties = JSON.parse(template.properties);
    return {
      color: properties.color,
      default: properties.default
    };
  } catch (error) {
    console.log(error);
  }

  return {};
};

export const useTemplatesForLocation = () => {
  const selectedLocationId = useMyLocation().id;
  const [{ data }, refetch] = useGetTemplatesForLocationQuery({ variables: { locationId: selectedLocationId } });

  return useMemo(() => {
    const templatesForLocation = data?.templatesForLocation || [];

    const templatesToUse = templatesForLocation;
    templatesToUse.sort((a, b) => a.target!.value - b.target!.value);

    if (templatesToUse.length === 0) {
      throw Error(`${BUSYNESS_TARGET_NAME} templates not set up for location ${selectedLocationId}`);
    }

    const templateOptions: TemplateOption[] = templatesToUse.map(template => ({
      name: template.name,
      id: template.id,
      template: template as ReadTemplate,
      ...getPropertiesFromTemplate(template as ReadTemplate)
    }));

    return { templateOptions, refetch };
  }, [data, refetch]);
};
